import { atom } from 'jotai';
import { Brand } from '@kheops/graphql';

export const brandsAtom = atom<Pick<Brand, 'value' | 'comment'>[]>([]);
